import type * as Collapsible from '@radix-ui/react-collapsible';
import * as React from 'react';

interface CollapsibleDrawerContextType extends Omit<Collapsible.CollapsibleProps, 'title'> {
  side: 'left' | 'right';
  title: string;
  contentWidth?: string;
}

const CollapsibleDrawerContext = React.createContext<CollapsibleDrawerContextType | undefined>(undefined);

interface CollapsibleDrawerProviderProps {
  value: CollapsibleDrawerContextType;
  children: React.ReactNode;
}

function CollapsibleDrawerProvider(props: CollapsibleDrawerProviderProps) {
  const { children, value } = props;

  return <CollapsibleDrawerContext.Provider value={value}>{children}</CollapsibleDrawerContext.Provider>;
}

function useCollapsibleDrawer() {
  const context = React.useContext(CollapsibleDrawerContext);

  if (context === undefined) {
    throw new Error('useCollapsibleDrawer must be used within a CollapsibleDrawerProvider');
  }

  return context;
}

export { CollapsibleDrawerProvider, useCollapsibleDrawer };
